// extracted by mini-css-extract-plugin
export var container = "_40-0";
export var error = "_40-9";
export var label = "_40-5";
export var light = "_40-6";
export var md = "_40-3";
export var sm = "_40-2";
export var thin = "_40-8";
export var thinBold = "_40-7";
export var vertical = "_40-4";
export var xs = "_40-1";